export default "__VITE_ASSET__DSlqEPRa__"